import {createContext, ReactElement, ReactNode} from "react";
import {
  FieldErrors,
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn,
  ValidationRule,
} from "react-hook-form";

import {getFormData} from "@/function/operationCommercialeToole";

type HookFormContextType<T extends FieldValues = any> = UseFormReturn<T> & {
  atLeastOneFilled: (
    names: string[],
    getValues: () => any,
    errorMessage?: string,
  ) => ValidationRule<boolean> | string;
  printError: (
    name: string,
    error: FieldErrors<any>,
  ) => ReactElement | undefined;
};

export const HookFormContext = createContext<HookFormContextType | null>(null);

export function HookFormContextProvider<T extends FieldValues>({
  children,
  defaultValues,
}: {
  children: ReactNode;
  defaultValues?: UseFormProps<T>["defaultValues"];
}): ReactElement {
  const methode = useForm<T>({
    mode: "onChange",
    defaultValues,
    shouldFocusError: true,
  });
  // Règle pour vérifier qu'au moin 1 champ est indiqué
  const atLeastOneFilled = (
    names: string[],
    getValues: (value?: string) => any,
    errorMessage: string | undefined = "Remplissez ce champ.",
  ): ValidationRule<boolean> | string => {
    return names.some(name => {
      const val = getValues(name);

      return (
        val !== undefined && val !== null && val !== "" && !isNaN(Number(val))
      );
    })
      ? false
      : errorMessage;
  };

  const printError = (
    name: string,
    errors: FieldErrors<any>,
  ): ReactElement | undefined => {
    const error = getFormData(errors, name);

    if (error) {
      return <p className="form-error">{error.toString()}</p>;
    }
  };
  return (
    <HookFormContext.Provider
      value={{...methode, atLeastOneFilled, printError}}>
      {children}
    </HookFormContext.Provider>
  );
}
